export { default } from "./src/polygon-call-to-action";
export type { UniformPolygonCallToActionProps } from "./src/polygon-call-to-action";
